import { ButtCon, Modal, Video } from "@biom3/react";
import type { PlayVideoMimeType } from "@ui-kit/QuestList";
import LazyReactPlayer from "react-player/lazy";

type VideoQuestModalProps = {
  videoUrl: string;
  videoMimeType: PlayVideoMimeType;
  onClose: () => void;
  onComplete?: () => void;
  muted?: boolean;
  showBgOverlay?: boolean;
  showControls?: boolean;
};

export const VideoQuestModal = ({
  videoUrl,
  videoMimeType,
  onClose,
  onComplete,
  muted = false,
  showBgOverlay = false,
  showControls = true,
}: VideoQuestModalProps) => (
  <Modal visible onCloseModal={onClose} showBgOverlay={showBgOverlay}>
    <Modal.Content
      sx={{
        borderRadius: "base.borderRadius.x10",
        position: "relative",
        overflow: "hidden",
        background: "base.color.fixed.black.1000",
        aspectRatio: "16/9",
        width: { default: "90dvw", small: "90dvw", large: "60dvw" },
      }}
    >
      {videoMimeType === "iframe/embed" ? (
        <LazyReactPlayer
          playsinline
          width="100%"
          height="100%"
          url={videoUrl}
          onEnded={onComplete}
          // @NOTE: sadly, this does not disable related videos on youtube anymore,
          // but when set to zero, it will only show related videos from the same channel
          // https://developers.google.com/youtube/player_parameters#rel
          config={{
            youtube: {
              playerVars: {
                rel: 0,
              },
            },
          }}
          controls={showControls ?? true}
          playing
        />
      ) : (
        <Video
          sx={{ w: "100%", h: "100%" }}
          mimeType={videoMimeType}
          videoUrl={videoUrl}
          autoPlay
          muted={muted}
          controls
          onEnded={onComplete}
        />
      )}
      <ButtCon
        icon="Close"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: "base.spacing.x4",
          right: "base.spacing.x4",
        }}
        variant="tertiary"
      />
    </Modal.Content>
  </Modal>
);
